import type { RezaOpravneniDto } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import { zastupujiciOsobaNazev } from '@gov-nx/module/page';
import { Space, Tile, Tiles } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';
import { pageRouteResolver } from '@gov-nx/web';

const ProfileRezaKeyValues = ({
	options,
}: {
	options: { label: string; value: string }[];
}) => (
	<div className="flex flex-col flex-wrap [ sm:gap-(--spacing-m) sm:flex-row ]">
		{options.map(({ label, value }) => (
			<div key={`key-value-${label}-${value}`}>
				<span className="text-(--text-tertiary)">{label}</span>
				<Space />
				<strong>{value}</strong>
			</div>
		))}
	</div>
);

interface ProfileRezaListRenderProps {
	headline: string;
	data: RezaOpravneniDto[];
}

export const ProfileRezaListRender = ({
	headline,
	data,
}: ProfileRezaListRenderProps) => {
	const { t } = useLocale('profil-reza');

	if (data.length === 0) {
		return null;
	}

	return (
		<section>
			<h2 className="text-headline-s! text-(--text-secondary)">{headline}</h2>
			<Tiles>
				{data.map((item) => (
					<Tile
						key={item.kod}
						headlineLink={true}
						name={zastupujiciOsobaNazev(item, { showIco: false })}
						to={pageRouteResolver('reza.detail', { id: item.kod })}
						icon={{ name: 'chevron-right', type: 'components' }}>
						<ProfileRezaKeyValues
							options={[
								{
									label: t('profil-reza.platnost-od') + ':',
									value: item?.platnostOd
										? toDateReadable(item.platnostOd)
										: '-',
								},
								{
									label: t('profil-reza.platnost-do') + ':',
									value: item?.platnostDo
										? toDateReadable(item.platnostDo)
										: t('profil-reza.platnost-neomezena'),
								},
							]}
						/>
					</Tile>
				))}
			</Tiles>
		</section>
	);
};
